import { Input } from "pages/ActivateInvitePage/Input/Input.component";
import { styled } from "theme/default/styled";

export const SInviteRepeatedPasswordInput = styled(Input)`
  margin-bottom: 10px;
`;
